export default "__VITE_ASSET__BEpu9PR5__"